// A file's size the way the order panels print it: whole KB below a megabyte,
// one decimal of MB above. Empty for a missing size.
export function fileSize(bytes) {
  if (!bytes) return ""
  const mb = bytes / (1024 * 1024)
  return mb >= 1 ? `${mb.toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`
}
